import {environment} from "environments";

(() => {
  angular.module('pims').directive('loader', ["$http", $http => {
    'ngInject';

    return {
      restrict: 'E',
      template: `
                 <div class="pims-loader-backdrop" ng-class="{'BOD_1837': BOD_1837}" ng-show="loadingText">
                   <div class="pims-loader">
                     <i class="pims-loader-spinner icon-logo"></i>
                     <div class="pims-loader-text" ng-bind="loadingText"></div>
                   </div>
                 </div>
                `,

      link(scope) {
        scope.BOD_1837 = ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV);
        const handleRequest = request => {
          if (request.loadingText) {
            scope.loadingText = request.loadingText;
          }
        };

        scope.$watch(() => $http.pendingRequests, (requests = []) => {
          if (!requests.length) {
            delete scope.loadingText;
            return;
          }

          requests.forEach(handleRequest);
        }, true);
      }

    };
  }]);
})();
